import { Components } from '@mui/material'

export const CardOverrides = (): Components['MuiCard'] => ({
  defaultProps: {},
  styleOverrides: {
    root: {},
  },
})
